import { ReactNode, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu } from './Menu';
import { HamburgerIcon, FairdropLogo } from './Icons';
import { useAuth } from '../contexts/AuthContext';

export type ThemeColor = 'coral' | 'green' | 'blue' | 'white' | 'dark';

interface LayoutProps {
  children: ReactNode;
  theme?: ThemeColor;
  showHeader?: boolean;
  headerRight?: ReactNode;
}

export function Layout({
  children,
  theme = 'coral',
  showHeader = true,
  headerRight,
}: LayoutProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { isLoggedIn, username, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className={`page theme-${theme}`}>
      {/* Mobile coming soon overlay */}
      {/* Inline style prevents FOUC (flash before CSS loads) */}
      <div className="mobile-overlay" style={{ display: 'none' }}>
        <FairdropLogo />
        <h2>Mobile version coming soon</h2>
        <p>Please use a desktop browser for now.</p>
      </div>

      {showHeader && (
        <header className="header">
          <div className="header-logo">
            <button
              className="icon-btn"
              onClick={() => setMenuOpen(true)}
              aria-label="Open menu"
            >
              <HamburgerIcon />
            </button>
            <Link to="/" style={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FairdropLogo />
              <span className="header-version">3.0.0</span>
            </Link>
          </div>
          <div className="header-actions">
            {headerRight || (
              isLoggedIn ? (
                <Link
                  to="/account/received"
                  style={{ color: 'inherit', textDecoration: 'none' }}
                >
                  {username}
                </Link>
              ) : (
                <Link
                  to="/account"
                  style={{ color: 'inherit', textDecoration: 'none' }}
                >
                  Log in / Register
                </Link>
              )
            )}
          </div>
        </header>
      )}

      <Menu
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        isLoggedIn={isLoggedIn}
        username={username || undefined}
        onLogout={handleLogout}
      />

      <main className="page-content">{children}</main>
    </div>
  );
}
